function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import features from "./features/index";
import observe from "./utils/observe";
import render from "./utils/render";

var checkEligibility = function checkEligibility(e, dataKeys) {
  if (dataKeys.join(',').indexOf('trimmings') === -1) {
    if (e.type === 'click') {
      var parent = e.target.closest('[data-trimmings-inline]');

      if (parent) {
        return {
          keys: ['trimmingsInline']
        };
      }
    }

    if (['change', 'input'].includes(e.type)) {
      var form = e.target.closest('form');

      if (form && typeof form.dataset.trimmingsAutosubmit !== 'undefined') {
        return {
          keys: ['trimmingsAutosubmit']
        };
      }
    }

    return null;
  }

  return {
    keys: dataKeys
  };
};

var featureHandles = Object.values(features).filter(function (f) {
  return f.key && f.eventNames && f.handle;
}).map(function (f) {
  return {
    key: f.key,
    eventNames: f.eventNames,
    handle: f.handle
  };
});

var init = function init() {
  Object.values(features).filter(function (f) {
    return typeof f.listen === 'function';
  }).forEach(function (f) {
    f.listen();
  });
  observe();
  render(document);
  var events = [[window, 'DOMContentLoaded'], [document, 'turbolinks:render'], [window, 'hashchange'], [window, 'popstate'], [window, 'pushstate'], [window, 'onorientationchange']];
  events.forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        context = _ref2[0],
        eventName = _ref2[1];

    context.addEventListener(eventName, function () {
      render(document);
    });
  });

  var handleEvent = function handleEvent(e) {
    var dataKeys = Object.keys(e.target.dataset);
    var eligibility = checkEligibility(e, dataKeys);

    if (!eligibility) {
      return true;
    }

    featureHandles.forEach(function (_ref3) {
      var key = _ref3.key,
          eventNames = _ref3.eventNames,
          handle = _ref3.handle;

      if (eligibility.keys.includes(key) && eventNames.includes(e.type)) {
        handle(e);
      }
    });
  };

  featureHandles.reduce(function (acc, h) {
    return acc.concat(h.eventNames);
  }, []).filter(function (m, i, a) {
    return a.indexOf(m) === i;
  }).forEach(function (type) {
    document.addEventListener(type, handleEvent);
  });
};

export default init;